import { PartnerRegistrationMode } from '@constants/app.constants';

export class PartnerFormModel {
  prename: string;
  lastname: string;
  email: string;
  password: string;
  password_repeat: string;
  name: string;
  company_size: string;
  industry: string;
  country_identifier: string;
  timezone: string;
  phone: number;
  mobile?: string;
  language_identifier?: string;
  partnership_uuid?: string;
  utm_source?: string;
  token?: string;
  country_code?: string;
  uuid?: string;
  is_verified_by_support?: boolean;
  job_title?: string;
  registration_mode?: PartnerRegistrationMode;
}
